import './SuccessStep.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const SuccessStep = _ref => {
  let {
    title,
    subTitle,
    icon,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "success-step"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: icon
    },
    className: "success-step-icon"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "success-step-main-title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "success-step-subtitle",
    dangerouslySetInnerHTML: {
      __html: subTitle
    }
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "c1j1xaav";
const ltrStyles = "lqt0uxx";
const rtlStyles = "r1y02sda";
export default SuccessStep;